import { render, staticRenderFns } from "./DialerFab.vue?vue&type=template&id=6dcfc88c&scoped=true"
import script from "./DialerFab.vue?vue&type=script&lang=js"
export * from "./DialerFab.vue?vue&type=script&lang=js"
import style0 from "./DialerFab.vue?vue&type=style&index=0&id=6dcfc88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcfc88c",
  null
  
)

export default component.exports